import React, { useState } from 'react';
import ERPApp from './ERPApp';

/* ═══════════════════════════════════════════════════════════
   DSR MATRIX ERP — Standalone Wrapper
   Fake login page → ERP platform
   ═══════════════════════════════════════════════════════════ */

const T = { bg: "#04080f", bg2: "#08101d", sf: "#0c1526", bdr: "#1a2d4d", tx: "#e8edf8", tx2: "#8fa3c4", tx3: "#556b8a", ac: "#2563eb", gn: "#36d98b" };

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin();
  };

  return (
    <div style={{ fontFamily: "'Inter',-apple-system,sans-serif", minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');*{box-sizing:border-box;margin:0}body{margin:0;background:${T.bg}}@keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}@keyframes glow{0%,100%{box-shadow:0 0 30px ${T.ac}20}50%{box-shadow:0 0 60px ${T.ac}40}}`}</style>
      <div style={{ width: '100%', maxWidth: 420, animation: 'fadeUp .5s ease' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 72, height: 72, borderRadius: 20, background: `linear-gradient(135deg, ${T.ac}, #3b82f6)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 800, color: '#fff', margin: '0 auto 20px', animation: 'glow 3s infinite' }}>EP</div>
          <h1 style={{ fontSize: 32, fontWeight: 800, color: T.tx, letterSpacing: '-.02em' }}>DSR <span style={{ color: T.ac }}>MATRIX</span> ERP</h1>
          <p style={{ color: T.tx3, fontSize: 13, marginTop: 6 }}>Complete Manufacturing ERP Platform</p>
        </div>

        <form onSubmit={handleSubmit} style={{ background: T.bg2, borderRadius: 16, padding: '28px 24px', border: `1px solid ${T.bdr}` }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ color: T.tx2, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.06em' }}>Email</label>
            <input type="text" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter any email" style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: `1px solid ${T.bdr}`, background: T.sf, color: T.tx, fontSize: 14, outline: 'none' }} />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ color: T.tx2, fontSize: 11, fontWeight: 600, display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.06em' }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter any password" style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: `1px solid ${T.bdr}`, background: T.sf, color: T.tx, fontSize: 14, outline: 'none' }} />
          </div>
          <button type="submit" style={{ width: '100%', padding: '14px', borderRadius: 12, border: 'none', background: `linear-gradient(135deg, ${T.ac}, #3b82f6)`, color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', boxShadow: `0 4px 20px ${T.ac}35` }}>
            Enter Demo →
          </button>
          <div style={{ marginTop: 14, padding: '10px 12px', background: `${T.ac}08`, border: `1px solid ${T.ac}20`, borderRadius: 8, textAlign: 'center' }}>
            <span style={{ fontSize: 11, color: T.tx3 }}>No signup needed. Enter any credentials to explore. All data resets on refresh.</span>
          </div>
        </form>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 10, color: T.tx3, opacity: 0.6 }}>
          <div>Powered by <strong style={{ color: T.ac }}>DSR MATRIX</strong> · <a href="https://dsrmatrix.com" target="_blank" rel="noreferrer" style={{ color: T.tx3, textDecoration: 'none' }}>dsrmatrix.com</a></div>
          <div style={{ marginTop: 4 }}>White-label solution available · <a href="mailto:support@dsrmatrix.com" style={{ color: T.tx3, textDecoration: 'none' }}>support@dsrmatrix.com</a></div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [loggedIn, setLoggedIn] = useState(true);

  if (!loggedIn) {
    return <LoginPage onLogin={() => setLoggedIn(true)} />;
  }

  return <ERPApp />;
}
